module.exports = __webpack_public_path__ + "img/Network.22e5311d.png";